import { defineStore, getActivePinia } from 'pinia';

export const resetAllStores = () => {
  const activepinia = getActivePinia();

  if (activepinia) {
    Object.entries(activepinia.state.value).forEach(([storeName, state]) => {
      const storeDefinition = defineStore(storeName, state);
      const store = storeDefinition(activepinia);

      store.$reset();
    });
  }

  // ToDo ideally all info should be on stores so no need for this, but not the case at the time
  localStorage.clear();
  sessionStorage.clear();
};
